<template lang="">
  <div>
    <svg xmlns="http://www.w3.org/2000/svg" width="53.66" height="53.66" viewBox="0 0 53.66 53.66">
  <g id="Dealer_Specials" data-name="Dealer Specials" transform="translate(-1134.53 -489.701)">
    <circle id="Ellipse_1081" data-name="Ellipse 1081" cx="26.33" cy="26.33" r="26.33" transform="translate(1135.03 490.201)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
    <g id="Group_9712" data-name="Group 9712" transform="translate(1147.8 505.52)">
      <path id="Path_70953" data-name="Path 70953" d="M10.215,23.877.83,14.511A1.089,1.089,0,0,1,.809,12.97L13.2.5h10a.95.95,0,0,1,1,1v9.979L11.759,23.9A1.094,1.094,0,0,1,10.215,23.877Z" transform="translate(-0.5 -0.5)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
      <path id="Path_70954" data-name="Path 70954" d="M9.69,11.569s-1.26,1.26.51,3.031c2.218,2.218,5.235-.8,3.466-3.466s1.247-5.684,3.465-3.465a1.8,1.8,0,0,1,.12,2.64" transform="translate(-0.5 -0.5)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
      <line id="Line_975" data-name="Line 975" x1="1.26" y2="1.26" transform="translate(16.751 6.028)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
      <line id="Line_976" data-name="Line 976" x1="1.26" y2="1.26" transform="translate(8.56 14.219)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
    </g>
  </g>
</svg>

  </div>
</template>
<script>
export default {
  props: {
    themeColor: {
      type: String,
      default: '#B3B3B3'
    },
    height: {
      type: String,
      default: '53.66px'
    },
    width: {
      type: String,
      default: '53.66px'
    }
  }
}
</script>
<style lang="">

</style>
